"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFiscalYearWindowStart = exports.getFiscalYearStartMonthNumber = exports.DEFAULT_FISCAL_YEAR_MONTH = exports.FISCAL_YEAR_MONTHS = void 0;
const enums_1 = require("../enums");
exports.FISCAL_YEAR_MONTHS = [
    enums_1.FiscalYearMonth.JANUARY,
    enums_1.FiscalYearMonth.FEBRUARY,
    enums_1.FiscalYearMonth.MARCH,
    enums_1.FiscalYearMonth.APRIL,
    enums_1.FiscalYearMonth.MAY,
    enums_1.FiscalYearMonth.JUNE,
    enums_1.FiscalYearMonth.JULY,
    enums_1.FiscalYearMonth.AUGUST,
    enums_1.FiscalYearMonth.SEPTEMBER,
    enums_1.FiscalYearMonth.OCTOBER,
    enums_1.FiscalYearMonth.NOVEMBER,
    enums_1.FiscalYearMonth.DECEMBER,
];
exports.DEFAULT_FISCAL_YEAR_MONTH = enums_1.FiscalYearMonth.JANUARY;
const getFiscalYearStartMonthNumber = (fiscalYearMonthStart) => exports.FISCAL_YEAR_MONTHS.indexOf(fiscalYearMonthStart ?? exports.DEFAULT_FISCAL_YEAR_MONTH) + 1;
exports.getFiscalYearStartMonthNumber = getFiscalYearStartMonthNumber;
const getFiscalYearWindowStart = (fiscalYearStartMonth, yearsBack, now = new Date()) => {
    const hasFiscalYearStartedThisCalendarYear = now.getUTCMonth() + 1 >= fiscalYearStartMonth;
    const startYear = now.getUTCFullYear() - (hasFiscalYearStartedThisCalendarYear ? 0 : 1) - yearsBack;
    return new Date(Date.UTC(startYear, fiscalYearStartMonth - 1, 1));
};
exports.getFiscalYearWindowStart = getFiscalYearWindowStart;
